// extracted by mini-css-extract-plugin
export default {"container":"ScrollChatBack_container__QyuqX","content":"ScrollChatBack_content__5JxVs","contentButton":"ScrollChatBack_contentButton__OFEeg"};